import { html, css } from 'lit-element';
import { FormElement } from './form-element-base';
import '@trumedianetworks/tmn-core-components/src/tmn-select';
import '@trumedianetworks/tmn-core-components/src/tmn-form-group';
import '@trumedianetworks/tmn-core-components/src/tmn-button';

class FormElementSelect extends FormElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            ...super.styles,
            css`
                :host {
                    display: flex;
                    flex-flow: column;
                    position: relative;
                }
                tmn-select {
                    min-width: 200px;
                    max-width: 200px;
                }
                .select-container {
                    display: flex;
                    flex-flow: row;
                    align-items: flex-end;
                }
                .select-container tmn-icon-button {
                    margin-left: 6px;
                    margin-bottom: 2px;
                }
            `,
        ];
    }

    render() {
        const { itemTemplate, value } = this;
        const { isOptional, type, options } = itemTemplate;
        const key = this.getKey();
        const multiple = type === 'MULTISELECT';

        if (!options?.length) {
            return html`<div>${key} is ${type} but has no options</div>`;
        }
        const dataForSelect = options.map((o) => {
            if (typeof o === 'string' || typeof o === 'number') {
                // turn into an object meeting the appropriate criteria
                return { name: o, displayKey: o.toString() };
            }
            if (!o.name) {
                o.name = o.displayKey;
            }
            if (!o.displayKey) {
                o.displayKey = o.name;
            }
            return o;
        });
        const valueForLookup = Array.isArray(value) ? value : [value];
        const selections = dataForSelect.filter((d) => valueForLookup.includes(d.name));
        const displayLabel = this.getDisplayLabel();
        if (this.isViewMode()) {
            // there are some cases where we can view but not edit
            // in that case we still want to show the selection even though
            // the user won't be able to edit it in edit mode (maybe there is a better approach, for now we just do this)
            const displaySelections = selections.length
                ? selections.map((s) => s.displayKey).join(', ')
                : valueForLookup.length
                ? valueForLookup.join(',')
                : `<EMPTY>`;
            return html`<tmn-form-group
                ><label>${displayLabel}:</label><span>${displaySelections}</span></tmn-form-group
            >`;
        }
        return html`<div class="select-container">
            <tmn-select
                .multiple=${multiple}
                @tmn-selections-changed=${this.handleSelectChanged}
                .data=${dataForSelect}
                .label=${displayLabel}
                .selections=${selections}></tmn-select
            >${this.renderClear()}
        </div>`;
    }

    renderClear() {
        const { itemTemplate, value } = this;
        const { isOptional } = itemTemplate;
        // todo review handling here for multiselect
        const hasValue = value?.length;
        if (isOptional && hasValue) {
            return html`
                <tmn-icon-button @click="${this.handleClear}">
                    <tmn-icon color="primary" icon="clear_all" iconvariant="outlined"></tmn-icon>
                </tmn-icon-button>
            `;
        }
        return null;
    }

    handleClear(e) {
        const { path } = this;
        this.actions.setStagedEditByPath(path, null);
    }

    handleSelectChanged(e) {
        const { path } = this;
        const { itemTemplate } = this;
        const { type } = itemTemplate;

        const { detail } = e;
        const { selections } = detail;
        const values = selections.map((s) => s.name);
        const multiple = type === 'MULTISELECT';
        const value = multiple ? values : values[0];
        this.actions.setStagedEditByPath(path, value);
    }
}

customElements.define('form-element-select', FormElementSelect);
